import type { RouteRecordRaw } from "vue-router";

export const timetableRoutes: RouteRecordRaw[] = [
  {
    path: "/timetable",
    name: "timetable-index",
    component: () => import("./TimetableCalendarPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/timetable/create",
    name: "timetable-create",
    component: () => import("./create.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/timetable/event-details/:calendarId/:eventId",
    name: "timetable-event-details",
    component: () => import("./event_details/[calendarId]/EventDetailPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/timetable/event-details/:calendarId/:eventId/lesson-plan",
    name: "timetable-event-lesson-plan",
    component: () => import("./event_details/[calendarId]/LessonPlanPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
